class CollectionTilesSlideMobile extends HTMLElement {
	constructor() {
		super();

		this.loadMoreStatus = this.getAttribute('data-loadMore') ? true : false;

		if (this.loadMoreStatus) {
			let idSection = this.getAttribute("id");

			this.listContainer = this.querySelector(
				`#Collection-product-grid--${idSection}`
			);
			this.buttonLoad = document.querySelector(`#Loadmore--${idSection}`);
			

			this.itemsPerClick = 4; // Number of items to show per click
			this.visibleItems = this.getAttribute('data-itemShow') ? parseInt(this.getAttribute('data-itemShow')) : 4; // Initially shown items
			this.items = this.listContainer?.querySelectorAll(".swiper-slide");

			this.buttonLoad.addEventListener("click", () => {
				this.loadMore();
			});
		
			this.showItems();
		}
		
		(function () {
			'use strict';
			const breakpoint = window.matchMedia('(min-width:750px)');
			let mySwiper;

			const breakpointChecker = function () {
				if (breakpoint.matches === true) {
					if (mySwiper !== undefined) mySwiper.destroy(true, true);
					return;
				} else if (breakpoint.matches === false) {
					return enableSwiper();
				}

			};

			const enableSwiper = function () {

				mySwiper = new Swiper('.collection-tiles-swiper', {
          loop: true,
					allowTouchMove: true,
					slidesPerView: 1,
					spaceBetween: 15,
          pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
				});

			};

			document.querySelectorAll('collection-tiles-mobile').forEach(function (element) {
				let disableSwiper = element.getAttribute('data-disable') && element.getAttribute('data-disable') == "true" ? true : false;
				if(!disableSwiper){
					breakpoint.addListener(breakpointChecker);
					breakpointChecker();
				}
			})

		})();
	}

	showItems = () => {
		for (let i = 0; i < this.visibleItems; i++) {
		  if (this.items[i]) {
			this.items[i].style.display = "block";
		  }
		}
	  };
  
	loadMore = () => {
		let hiddenItems = Array.from(this.items).filter(
		  (item) => item.style.display === "none"
		);
  
		for (let i = 0; i < this.itemsPerClick; i++) {
		  if (hiddenItems[i]) {
			hiddenItems[i].style.display = "block";
		  }
		}
  
		// Hide button when all items are shown
		if (
		  Array.from(this.items).every((item) => item.style.display === "block")
		) {
		  this.buttonLoad.style.display = "none";
		}
	 };
}
if(!customElements.get("collection-tiles-mobile")){
	customElements.define("collection-tiles-mobile", CollectionTilesSlideMobile);
}
